export enum HeatingTypeEnum {
  CHAUFFAGE_INDIVIDUEL = "CHAUFFAGE_INDIVIDUEL",
  CHAUFFAGE_COLLECTIF = "CHAUFFAGE_COLLECTIF",
}

export const heatingTypeEnumLabels = [
  { value: HeatingTypeEnum.CHAUFFAGE_COLLECTIF, label: "Collectif" },
  { value: HeatingTypeEnum.CHAUFFAGE_INDIVIDUEL, label: "Individuel" },
]
